module.exports = __webpack_public_path__ + "img/pålestikk_tredd_3.6eaa85e0.jpg";